import { Provider } from '@angular/core';
import { UsersDataHttpService } from './abstract';
import { UsersDataHttpServiceImpl } from './users-data-http.service';

export const UsersDataHttpProvider: Provider = {
	provide: UsersDataHttpService,
	useClass: UsersDataHttpServiceImpl,
};
